const rawApiUrl = process.env.REACT_APP_API_URL || '';

export const apiBaseUrl = rawApiUrl.replace(/\/+$/, '');

export const getApiUrl = () => apiBaseUrl;

export const buildApiUrl = (path = '') => {
  if (!apiBaseUrl) return '';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiBaseUrl}${normalizedPath}`;
};

export const showMissingApiUrlAlert = () => {
  window.alert(
    'No esta configurada la URL del backend para este entorno. Revisa REACT_APP_API_URL en Railway y redeploy del web.'
  );
};
